import { usePlayer } from "@/store/PlayerContext";
import { Play, Pause, X } from "lucide-react";

function formatTime(s) {
  if (!s || Number.isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec.toString().padStart(2, "0")}`;
}

export default function StickyPlayer() {
  const { current, playing, toggle, progress, duration, seek, close } = usePlayer();
  if (!current) return null;
  const pct = duration ? (progress / duration) * 100 : 0;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 player-bar" data-testid="sticky-player">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-4">
        <button
          onClick={toggle}
          className="btn-primary w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 pulse-blue"
          data-testid="player-toggle-btn"
          aria-label={playing ? "Pause" : "Play"}
        >
          {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
        </button>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-3 mb-1.5">
            <div className="truncate">
              <span className="font-display font-bold text-[var(--text)] text-sm sm:text-base truncate">
                {current.title}
              </span>
              {current.genre && (
                <span className="text-[var(--text-dim)] text-xs ml-2 hidden sm:inline">
                  {current.genre}{current.bpm ? ` · ${current.bpm} BPM` : ""}{current.key_signature ? ` · ${current.key_signature}` : ""}
                </span>
              )}
            </div>
            <span className="text-xs text-[var(--text-dim)] tabular-nums flex items-center gap-2">
              <span className="tag-pill-blue hidden sm:inline-flex !text-[9px] !py-0">30s preview</span>
              {formatTime(progress)} / {formatTime(duration)}
            </span>
          </div>
          <div
            className="h-2 bg-[var(--bg-elev)] rounded-full cursor-pointer overflow-hidden border-2 border-[var(--ink)]"
            onClick={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              seek((e.clientX - rect.left) / rect.width);
            }}
            data-testid="player-progress-bar"
          >
            <div
              className="h-full bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] transition-[width]"
              style={{ width: `${pct}%` }}
            />
          </div>
        </div>
        <button
          onClick={close}
          className="text-[var(--text-dim)] hover:text-[var(--text)] p-2"
          aria-label="Close player"
          data-testid="player-close-btn"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
